<script setup lang="ts">
import DefaultModalBase from "./DefaultModalBase.vue";
import { useModalStore } from "../../store/modal"
import { useAuthStore } from "../../store/auth";

const  modalStore = useModalStore()
const authStore = useAuthStore()

const logout = async () => {
    modalStore.close()
     await authStore.logout()
}
</script>

<template>
<default-modal-base icon="arrow-logout" heading="Are you sure you want to log out?">
    <div class="logout-modal-button-container">
        <brand-button @click="logout">Yes, log out</brand-button>
        <brand-button variant="secondary" @click="modalStore.close()">Nevermind</brand-button>
    </div>
</default-modal-base>
</template>

<style scoped lang="scss">
.logout-modal-button-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
</style>
